import { createColumnHelper } from '@tanstack/react-table';

import { Application } from './types';

export const helper = createColumnHelper<Application>();
